import React from "react";

import { IUserVehicle } from "Bands/types";
import { TeaserProps } from "shared/components";
import { DocumentTeaser } from "./DocumentTeaser";

interface Props extends IUserVehicle, TeaserProps {}

export const VehicleTeaser: React.FC<Props> = ({ ...rest }) => {
  return <DocumentTeaser {...rest} />;
};
